import React from "react";
import {
  Megaphone,
  Clapperboard,
  Image as ImageIcon,
  Building2,
  Video,
  CalendarDays,
  Mic2,
  Smartphone,
  Camera,
  ArrowUpRight,
} from "lucide-react";

import "./OurWork.css";

const workItems = [
  {
    title: "CAMPAIGNS",
    description:
      "Big ideas with a clear point of view. Built to move people and markets.",
    icon: Megaphone,
  },
  {
    title: "COMMERCIALS",
    description:
      "Short stories that grab attention and drive action. Made to perform.",
    icon: Clapperboard,
  },
  {
    title: "BRAND FILMS",
    description:
      "Cinematic stories that build affinity, trust and long-term brand value.",
    icon: ImageIcon,
  },
  {
    title: "CORPORATE FILMS",
    description:
      "Communicating purpose, culture and capability with clarity.",
    icon: Building2,
  },
  {
    title: "DOCUMENTARIES",
    description:
      "Real stories. Raw truth. Human experiences that inspire and create impact.",
    icon: Video,
  },
  {
    title: "EVENTS",
    description:
      "Experiences that bring people together and create lasting memories.",
    icon: CalendarDays,
  },
  {
    title: "PODCASTS & INTERVIEWS",
    description:
      "Conversations that inform, inspire and spark ideas worth sharing.",
    icon: Mic2,
  },
  {
    title: "SOCIAL & VERTICAL FILMS",
    description:
      "Scroll-stopping content designed for today's fast-moving world.",
    icon: Smartphone,
  },
  {
    title: "PHOTOGRAPHY & CREATIVES",
    description:
      "Striking visuals and designs that capture essence and elevate brands.",
    icon: Camera,
  },
];

function OurWork() {
  return (
    <section className="work-section" id="projects">

      {/* TOP CONTENT */}
      <div className="work-top">

        <div className="work-heading-area">
          <div className="work-brand-statement">
            <h3>Encapsulating Brands Into Culture.</h3>

            <p>
              Partnering with Challenger Brands, that love telling brand stories
              on digital platforms.
            </p>
          </div>

          <span className="work-tag">CULTURE AT WORK</span>
          <h2 className="work-heading">
            Where Ideas
            <br />
            <span>Come to Life</span>
          </h2>

          <p className="work-intro">
            Behind every great brand is a culture that creates with intention.
            <br />
            Here's a glimpse into how we think, create and collaborate.
          </p>
        </div>



      </div>

      {/* CARDS */}
      <div className="work-grid">

        {workItems.map((item, index) => {
          const Icon = item.icon;

          return (
            <div
              className="work-card"
              key={index}
              onClick={() => {
                if (item.title === "CAMPAIGNS") {
                  window.location.href = "/campaigns";
                }
                if (item.title === "BRAND FILMS") {
                  window.location.href = "/brand-films";
                }
                if (item.title === "COMMERCIALS") {
                  window.location.href = "/commercials";
                }
                if (item.title === "CORPORATE FILMS") {
                  window.location.href = "/corporate-films";
                }
                if (item.title === "EVENTS") {
                  window.location.href = "/events";
                }
                if (item.title === "DOCUMENTARIES") {
                  window.location.href = "/documentaries";
                }
                if (item.title === "PODCASTS & INTERVIEWS") {
                  window.location.href = "/podcasts";
                }
                if (item.title === "SOCIAL & VERTICAL FILMS") {
                  window.location.href = "/visual-gallery";
                }
                if (item.title === "PHOTOGRAPHY & CREATIVES") {
                  window.location.href = "/photography";
                }
              }}
            >

              <div className="work-card-icon">
                <Icon size={62} strokeWidth={1.35} />
              </div>

              <div className="work-card-content">

                <h3>{item.title}</h3>

                <p>{item.description}</p>

              </div>

              <div className="work-card-arrow">
                <ArrowUpRight size={22} strokeWidth={1.4} />
              </div>

            </div>
          );
        })}

      </div>

      {/* BOTTOM LINE */}
      <div className="work-bottom">

        <span></span>

        <p>
          DIFFERENT DISCIPLINES. ONE CULTURE. ENDLESS STORIES.
        </p>

        <span></span>

      </div>

    </section>
  );
}

export default OurWork;